import React, { forwardRef } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Player } from 'video-react';
import 'video-react/dist/video-react.css'; // import css

const Video = ({ src, ...rest }, ref) => {
  const data = useStaticQuery(graphql`
    query {
      placeholderVideo: allFile(
        filter: {
          sourceInstanceName: { eq: "images" }
          extension: { eq: "mp4" }
        }
      ) {
        edges {
          node {
            publicURL
            relativePath
          }
        }
      }
    }
  `);

  const video = data.placeholderVideo.edges.find(element => {
    return element.node.relativePath === src;
  });

  if (!video) {
    return null;
  }

  return <Player ref={ref} {...rest} src={video.node.publicURL} />;
};

export default forwardRef(Video);
